import { render, staticRenderFns } from "./CategorySettingDashboard.vue?vue&type=template&id=3ab514c2&scoped=true"
import script from "./CategorySettingDashboard.vue?vue&type=script&lang=js"
export * from "./CategorySettingDashboard.vue?vue&type=script&lang=js"
import style0 from "./CategorySettingDashboard.vue?vue&type=style&index=0&id=3ab514c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab514c2",
  null
  
)

export default component.exports